import { gql } from '@apollo/client'

export const FETCH_ALL_COACH_PROFILES = gql`
  query allCoachProfiles(
    $appointmentKind: EhrAppointmentKind
    $licensedState: AddressState
    $specialties: [EhrCoachSpecialty!]
    $recommended: Boolean!
    $insurancePlan: UserInsurancePolicyKind
    $excludedCoachIds: [ID!]
    $page: Int
    $perPage: Int
  ) {
    allCoachProfiles(
      appointmentKind: $appointmentKind
      licensedState: $licensedState
      specialties: $specialties
      recommended: $recommended
      insurancePlan: $insurancePlan
      excludedCoachIds: $excludedCoachIds
      page: $page
      perPage: $perPage
    ) {
      coachProfiles {
        id
        bio
        photo
        credentials
        fullName
        coachId
        specialties {
          key
          name
        }
        endDate
      }
    }
  }
`
